// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { combineReducers, createSlice } from '@reduxjs/toolkit';
import { IPanoState } from 'Utils/typings/state/esriSplitViewer';
import { ClearAnnotationSuccessAction, ClearPanoFeaturesAction, CreateAnnotationSuccessAction, DeleteAnnotationSuccessAction, EditAnnotationSuccessAction, GetAllAnnotationSuccessAction, LoadPanoFeaturesSuccessAction } from './esriSplitViewerActions';

const initialState: IPanoState = {
  features: [],
};
const annotationInitialState = {
  list: [],
};
const panoSlice = createSlice({
  name: 'pano',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(LoadPanoFeaturesSuccessAction, (state, action) => {
      state.features = action.payload; // store pano feature in the redux state
    })
      .addCase(ClearPanoFeaturesAction, (state) => {
        state.features = []; // remove pano features
      });
  },
});
const annotationSlice = createSlice({
  name: 'annotation',
  initialState: annotationInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllAnnotationSuccessAction, (state, action) => {
      state.list = action.payload;
    }).addCase(ClearAnnotationSuccessAction, (state, action) => {
      state.list = null;
    }).addCase(CreateAnnotationSuccessAction, (state, action) => {
      const orderId = action.payload.properties.order_id;
      const oldFeatureList = state.list[orderId].features;
      oldFeatureList.push(action.payload);
    })
      .addCase(EditAnnotationSuccessAction, (state, action) => {
        const orderId = action.payload.properties.order_id;
        const EditFeatureList = state.list[orderId].features;
        const index = EditFeatureList.findIndex((a) => a.properties.id === action.payload.properties.id);
        if (index !== -1) {
          EditFeatureList.splice(index, 1);
        }
        EditFeatureList.push(action.payload);
      })
      .addCase(DeleteAnnotationSuccessAction, (state, action) => {
        const orderId = Object.keys(action.payload)[0];
        const DeletedId = action.payload[orderId];
        const FeatureList = state.list[orderId].features;
        const index = FeatureList.findIndex((a) => a.properties.id === DeletedId);
        if (index !== -1) {
          FeatureList.splice(index, 1);
        }
      });
  },
});
export const panoReducer = panoSlice.reducer;
export const annotationReducer = annotationSlice.reducer;
const rootReducer = combineReducers({
  pano: panoReducer,
  annotation: annotationReducer,
});
export default rootReducer;
